import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { useUpdateTechnicalWorkDescriptionMutation } from "../technicalApi";
import { TECHNICAL_DESCRIPTION_LABEL } from "../technicalStatusMaps";

// Two-stage complaint wording (Technical.EditComplaint).
//
// Whoever takes the call writes what the customer said ("remote not working");
// someone with more product knowledge rewrites it into something a technician
// can act on ("check the transmitter feeding that remote"). The previous text
// is never lost - it goes to the activity log and shows struck through on the
// History timeline, which is why the current wording is shown greyed above the
// field rather than just pre-filled into it.
//
// COMPLAINT and SERVICE_VISIT only - an Installation's scope comes from its
// Sales Order and the API refuses this path for it.
const EditDescriptionModal = ({ show, onClose, work }) => {
  const [updateDescription, { isLoading }] = useUpdateTechnicalWorkDescriptionMutation();
  const [description, setDescription] = useState("");
  const [notes, setNotes] = useState("");

  useEffect(() => {
    if (!show) return;
    setDescription(work?.complaintDescription || "");
    setNotes("");
  }, [show, work?.complaintDescription]);

  const handleSave = async () => {
    if (!description.trim()) return toast.error("A description is required");
    try {
      await updateDescription({
        recordGuid: work.recordGuid,
        description: description.trim(),
        notes: notes.trim() || null,
      }).unwrap();
      toast.success("Description updated");
      onClose();
    } catch (e) {
      toast.error(e?.message || "Could not update the description");
    }
  };

  const unchanged = description.trim() === (work?.complaintDescription || "").trim();

  return (
    <Modal show={show} onHide={isLoading ? undefined : onClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Edit {TECHNICAL_DESCRIPTION_LABEL[work?.sourceType] || "Description"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label className="form-label text-muted">Current wording</label>
          <div className="p-2 bg-light rounded text-muted small">{work?.complaintDescription || "-"}</div>
        </div>
        <div className="mb-3">
          <label className="form-label">New wording <span className="text-danger">*</span></label>
          <textarea className="form-control" rows={4} value={description} onChange={(e) => setDescription(e.target.value)} />
          <small className="text-muted">The original wording is kept and shown on the History timeline.</small>
        </div>
        <div className="mb-1">
          <label className="form-label">Why it changed <span className="text-muted">(optional)</span></label>
          <input type="text" className="form-control" value={notes} onChange={(e) => setNotes(e.target.value)} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isLoading}>Cancel</Button>
        <Button variant="primary" onClick={handleSave} disabled={isLoading || unchanged}>
          {isLoading ? "Saving..." : "Save Wording"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditDescriptionModal;
